import * as React from 'react'
import { cn } from '../../lib/utils'

export interface PropertyFieldProps extends React.HTMLAttributes<HTMLParagraphElement> {
	label: string
	value?: string | number | null
}

function PropertyField({ label, value, className, ...props }: PropertyFieldProps) {
	return (
		<p
			data-slot="property-field"
			className={cn('text-sm leading-5 text-(--color-muted-foreground)', className)}
			{...props}
		>
			{label}: <span className="text-(--color-foreground)">{value ?? '—'}</span>
		</p>
	)
}

PropertyField.displayName = 'PropertyField'

export interface PropertyFieldListProps extends React.HTMLAttributes<HTMLDivElement> {}

function PropertyFieldList({ className, ...props }: PropertyFieldListProps) {
	return (
		<div
			data-slot="property-field-list"
			className={cn('flex w-[252px] flex-col gap-2', className)}
			{...props}
		/>
	)
}

PropertyFieldList.displayName = 'PropertyFieldList'

export interface PropertyFieldGroupProps extends React.HTMLAttributes<HTMLDivElement> {}

function PropertyFieldGroup({ className, ...props }: PropertyFieldGroupProps) {
	return (
		<div
			data-slot="property-field-group"
			className={cn('flex gap-4', className)}
			{...props}
		/>
	)
}

PropertyFieldGroup.displayName = 'PropertyFieldGroup'

export { PropertyField, PropertyFieldList, PropertyFieldGroup }
